import { AddComplimentaryPeriodFormValues } from './add-complimentary-period-form';
import { CppPayload } from './add-complimentary-period-modal';

export function prepareCppData(data: AddComplimentaryPeriodFormValues): CppPayload {
  return {
    expDate: data.cppExpirationDate?.format('YYYY-MM-DD') || '',
    partnerProductId: data.partnerProductId,
  };
}
